import { ICellRendererParams } from "ag-grid-community";
import { useMemo } from "react";

import { OrganizationSummaryDto } from "@intelligems/ig-types";

export const BillingCycleColumn = (
  params: ICellRendererParams<OrganizationSummaryDto, boolean>
) => {
  const mode = useMemo(() => {
    if (!params.data) {
      return null;
    }

    if (
      !params.data.organizationSubscriptions.length &&
      !params.data.stripeSubscriptionSummaries.length
    ) {
      return "-";
    }

    const hasMonthly = [
      ...params.data.organizationSubscriptions,
      ...params.data.stripeSubscriptionSummaries,
    ].some((s) => s.interval === "month");

    const hasAnnual = [
      ...params.data.organizationSubscriptions,
      ...params.data.stripeSubscriptionSummaries,
    ].some((s) => s.interval === "year");

    if (hasAnnual && hasMonthly) {
      return "Varies";
    }
    if (hasMonthly) {
      return "Monthly";
    }
    if (hasAnnual) {
      return "Yearly";
    }
    return null;
  }, []);

  return mode;
};
